import { render } from "./chatStoreList.vue?vue&type=template&id=3668b307"
import script from "./chatStoreList.vue?vue&type=script&lang=js"
export * from "./chatStoreList.vue?vue&type=script&lang=js"

import "./chatStoreList.vue?vue&type=style&index=0&id=3668b307&lang=scss"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__